renderCurrencySymbol